import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppointmentsService } from '../../../appointments/appointments.service';
import { UserInfoService } from '../../services/security.service';
import { ShareConfigService } from '../../services/shareConfig.service';
import { SharedService } from '../../services/shared.service';
import { suggestionEnum } from './suggestion-enum/suggestionEnum';

@Component({
  selector: 'app-suggestion-panel',
  templateUrl: './suggestion-panel.component.html',
  styleUrls: ['./suggestion-panel.component.scss']
})

export class SuggestionPanelComponent implements OnInit{
  @Input() suggestionType: any;
  @Input() officeId : any;
  @Input() tab:any;
  @Input() firstTimeGlobalAdmin:any;
  public userInfo: any = {};
  public companyCode: any;
  public suggestionDataAvailable: any = [];
  public suggetionFilters: any;
  areSuggestionsAvailable: any = [];
  showSuggestionDrpDwn: boolean = false;
  public hoverOnFilterHolder: boolean = false;
  appliedFilters: any = [];
  public snippet: string = "";
  public timeoutToFetchUser: any = null;
  public isFullFilterList: boolean = false;
  suggestionDataAvailableTemp: any = {};
  private responceObject:any = {};
  public officeList = [];
  private quizTagsReadyToFilterSubscription: Subscription;

  constructor(
    private userInfoService: UserInfoService,
    private sharedService: SharedService,
    private shareConfigService: ShareConfigService,
    private appointmentsService: AppointmentsService
  ) { 
  }

  ngOnInit() {
    // get user info
    this.userInfo = this.userInfoService._info;
    this.companyCode = this.sharedService.getCookie("clientCode");
    this.officeList = this.userInfoService.get().OfficeList;
    if(this.suggestionType == suggestionEnum.Calendar){
    this.suggestionDataAvailable = this.shareConfigService.suggestionOptionsForCalendar;
    this.suggetionFilters = this.shareConfigService.suggetionFilters;
    }else if(this.suggestionType == suggestionEnum.AppointmentType){
    this.suggestionDataAvailable = this.shareConfigService.suggestionOptionsForAppointment;
    this.suggetionFilters = this.shareConfigService.suggetionFiltersForAppointment;
    }
    this.shareConfigService.currentSearchSection.subscribe((res) => {
      if (res) {
        this.areSuggestionsAvailable = [];
      }
    });

       this.quizTagsReadyToFilterSubscription = this.shareConfigService.quizTagsReadyToFilterObservable
      .subscribe((item: any) => {
        if (item.TagId) {
          this.applyFilterBasedOnSuggestion('Tag',this.shareConfigService.quizTagsReadyToFilter);
        }
    });

  }

  getSuggestions(userSnip: any) {
    if (!userSnip) {
      this.areSuggestionsAvailable = [];
      return false;
    }
    this.suggestionForAppointmentData(userSnip);
  }

  suggestionForAppointmentData(userSnip: any) {
    clearTimeout(this.timeoutToFetchUser);
    this.timeoutToFetchUser = setTimeout(() => {
      this.suggestionForAppointment(userSnip);
    }, 500);
  }

  suggestionForAppointment(userSnip: any) {
   let isGlobalAdmin = this.userInfo.IsGlobalOfficeAdmin;
   let IsDataforGlobalOfficeAdmin:boolean = false;
   let officeId = this.officeId;

   if(isGlobalAdmin){
    if(this.officeId.length > 0 && this.officeList.length > 0 && this.officeId.length == this.officeList.length){
      IsDataforGlobalOfficeAdmin = true;
      officeId = [];
    }
   }
    let obj;
    if(this.suggestionType == suggestionEnum.AppointmentType){
      let companyWise = this.tab == 'tab1' ? true : false;
      if(this.firstTimeGlobalAdmin && companyWise == false){
        IsDataforGlobalOfficeAdmin = true;
      }
      obj = {
        "searchText": userSnip,
        "officeIdList": officeId,
        "companyWise": companyWise,
        "IsDataforGlobalOfficeAdmin":IsDataforGlobalOfficeAdmin
      }
    }else if(this.suggestionType == suggestionEnum.Calendar){
      if(this.firstTimeGlobalAdmin){
        IsDataforGlobalOfficeAdmin = true;
      }
      obj = {
        "searchText": userSnip,
        "officeIdList": officeId,
        "companyWise": false,
        "IsDataforGlobalOfficeAdmin":IsDataforGlobalOfficeAdmin
      }
    }
    this.appointmentsService.getSuggestion(obj).subscribe(response => {
      this.getSuggestionList(response);
    });
  }

  getSuggestionList(response) {
    this.responceObject = response;

    for (let currObj in this.responceObject) {
      this.suggestionDataAvailableTemp[currObj] = new Array<any>();
      this.suggestionDataAvailableTemp[currObj] = this.responceObject[currObj];
    }

    this.suggestionDataAvailable = this.suggestionDataAvailable.filter((currObj: any, index: any) => {
      if (this.suggestionDataAvailableTemp[currObj.code] && this.suggestionDataAvailableTemp[currObj.code].length > 0) {
        currObj.suggestions = [];
        currObj.suggestions = this.suggestionDataAvailableTemp[currObj.code];
        if (!this.areSuggestionsAvailable.includes(currObj.code)) {
          this.areSuggestionsAvailable.push(currObj.code);
        }
        return currObj;
      }
      else {
        currObj.suggestions = [];
        if (this.areSuggestionsAvailable.includes(currObj.code)) {
          this.areSuggestionsAvailable.splice(this.areSuggestionsAvailable.indexOf(currObj.code), 1);
        }
        return currObj;
      }
    });
  }


    // apply Filter Based On Suggestion
    applyFilterBasedOnSuggestion(filterCode: string, searchValue: any){
      let searchValueToSend:string = "";
      let searchTextToSend:string = "";
      if(filterCode.toLowerCase() === "calendars"){
        searchValueToSend = searchValue.Id;
        searchTextToSend = searchValue.Title;
      }
      else if(filterCode.toLowerCase() === "appointments"){
        searchValueToSend = searchValue.AutomationTypeId;
        searchTextToSend = searchValue.AutomationTypeName;
      }
      else if(filterCode.toLowerCase() === "tag"){
        searchValueToSend = searchValue.TagId;
        searchTextToSend = searchValue.TagName;
      }
      else{
        searchValueToSend = searchValue;
        searchTextToSend = searchValue;
      }
      this.allValueForSuggetionFilter(filterCode, searchValueToSend, searchTextToSend, 'contain');
      this.areSuggestionsAvailable = [];
      this.snippet = '';
    }
  
    allValueForSuggetionFilter(filterCode: string, searchValue: string, searchText:string, filterOperator: string) {
      let tempObj: any = {};
      for (let currObj of this.suggetionFilters) {
        if (currObj.searchName.toLowerCase() === filterCode.toLowerCase()) {
          tempObj = {};
          tempObj = Object.assign({}, currObj);
          tempObj.searchValue = searchValue;
          tempObj.textToDisplay = searchText;
          tempObj.filterCode = filterCode;
  
          if(currObj.type.toLowerCase() == "multi"){
            let isExistingValue: boolean = true;
            this.appliedFilters.map(function (item:any) {
              if (item.filterCode.toString() == filterCode.toString()) {
                if(!item.searchValue.toString().includes(tempObj.searchValue)){
                  item.searchValue += ',' + tempObj.searchValue;
                  item.textToDisplay += ', ' + tempObj.textToDisplay;
                }
                tempObj = item;
                isExistingValue = false;
              }
            });
  
            if(isExistingValue){
              this.appliedFilters = this.appliedFilters.filter((currObj:any) => {
                if (currObj.filterCode.toString() !== filterCode.toString()) {
                  return currObj;
                }
              });
              this.appliedFilters.push(tempObj);
            }
            
          }
          else if(currObj.type.toLowerCase() == "single"){
            this.appliedFilters = this.appliedFilters.filter((currObj:any) => {
              if (currObj.filterCode.toString() !== filterCode.toString()) {
                return currObj;
              }
            });
            this.appliedFilters.push(tempObj);
          }
        }
      }
  
      // call For Automation Suggestion Filtered Data
      if(this.suggestionType == suggestionEnum.Calendar){
        if(!this.shareConfigService.appointmentSuggestionFilteredData.viewData){
          this.shareConfigService.appointmentSuggestionFilteredData.viewData = [];
        }
        this.shareConfigService.appointmentSuggestionFilteredData.viewFor = tempObj.filterCode;
        this.shareConfigService.appointmentSuggestionFilteredData.viewData = this.shareConfigService.appointmentSuggestionFilteredData.viewData.filter((currObj: any, index: any) => {
          if (currObj.filterCode.toString() !== tempObj.filterCode.toString()) {
            return currObj;
          }
        });
        this.shareConfigService.appointmentSuggestionFilteredData.viewData.push(tempObj);
        this.shareConfigService.changeAppointmentSuggestionFilteredData();
      }
      if(this.suggestionType == suggestionEnum.AppointmentType){
        if(!this.shareConfigService.appointmentTypeSuggestionFilteredData.viewData){
          this.shareConfigService.appointmentTypeSuggestionFilteredData.viewData = [];
        }
        this.shareConfigService.appointmentTypeSuggestionFilteredData.viewFor = tempObj.filterCode;
        this.shareConfigService.appointmentTypeSuggestionFilteredData.viewData = this.shareConfigService.appointmentTypeSuggestionFilteredData.viewData.filter((currObj: any, index: any) => {
          if (currObj.filterCode.toString() !== tempObj.filterCode.toString()) {
            return currObj;
          }
        });
        this.shareConfigService.appointmentTypeSuggestionFilteredData.viewData.push(tempObj);
        this.shareConfigService.changeAppointmentTypeSuggestionFilteredData();
      }
    }

    removeFilter(removeFilteredFor:any){
      this.appliedFilters.splice(this.appliedFilters.indexOf(removeFilteredFor), 1);
      // remove For Automation Suggestion Filtered Data
  
      // call For Automation Suggestion Filtered Data
      if(this.suggestionType == suggestionEnum.Calendar){
        this.shareConfigService.appointmentSuggestionFilteredData.viewFor = removeFilteredFor.filterCode;
        this.shareConfigService.appointmentSuggestionFilteredData.viewData.splice(this.shareConfigService.appointmentSuggestionFilteredData.viewData.indexOf(removeFilteredFor), 1);
        this.shareConfigService.changeAppointmentSuggestionFilteredData();
      }
      if(this.suggestionType == suggestionEnum.AppointmentType){
        this.shareConfigService.appointmentTypeSuggestionFilteredData.viewFor = removeFilteredFor.filterCode;
        this.shareConfigService.appointmentTypeSuggestionFilteredData.viewData.splice(this.shareConfigService.appointmentTypeSuggestionFilteredData.viewData.indexOf(removeFilteredFor), 1);
        this.shareConfigService.changeAppointmentTypeSuggestionFilteredData();
      }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/suggestion-panel/suggestion-panel.component.ts